<template lang="pug">
  transition(name="fade" mode="out-in")
    router-view
</template>

<script>

import { mapActions } from 'vuex'
export default {
  name: 'b2b-page-auditorias',
  methods: {
    ...mapActions([
      'B2bCreateConfig',
      'setUserNameAudit'
    ])
  },
  created () {
    this.setUserNameAudit()
    this.B2bCreateConfig()
  }
}
</script>

<style lang="scss" scoped>

</style>
